export const payoutMethodKinds = ['bank', 'bizum'] as const

export type PayoutMethodKind = (typeof payoutMethodKinds)[number]

export type PayoutDestination = {
	kind: PayoutMethodKind
	label: string
	details: string
}

export type PayoutMethod = Omit<PayoutDestination, 'details'>

export type PayoutDetails = {
	bank_account: string
	bizum_phone: string
	payout_method: PayoutMethodKind | ''
}
